import defaultConfig from './defaultCon'

let adapter = {
  beijing: {
    sim: 'bj',
    cn: '北京'
  },
  shenzhen: {
    sim: 'sz',
    cn: '深圳'
  }
}

export { adapter }

export default function (l) {
  if (adapter[l]) {
    return adapter[l].sim
  } else if (l === '-1') {
    return adapter[defaultConfig.location].sim
  } else {
    return l
  }
}
